import React, { useState, useEffect, useCallback } from 'react';
import { createClient } from '@supabase/supabase-js';
import { sb } from './supabase';
import './App.css';

const IG_TOKEN = 'IGAAONH3T1zM9BZAGF3ZAnkxeDJVZAFBJZAXNFMUEwTmtJZAi0yN2xDYktERGNJRkRsck9zSS0wemFtTFl5bHdDWWt2ZAmRudkI2ZA2s1WC1XWGZASMHBSMjJvUmYxX2NsU2RWUDV2QXZA0VTVDX0JzOWY0a2xsZA0h6ZA3RTa3VTUVRoOTZAISQZDZD';
const IG_USER_ID = '26770455472615914';
const SUPABASE_URL_NEW = 'https://yczjxadbbfyluxswqjnn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inljemp4YWRiYmZ5bHV4c3dxam5uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAyNTYwMDAsImV4cCI6MjA5NTgzMjAwMH0.hYP1o16qSIwIvmxGAka91owKtFPZ-1RzIE3nTP5Emv0';
const ANALYTICS_USER_ID = '2f643ddb-baf0-49b0-901b-891f5776ed73';
const FB_APP_ID = '1314288600705533';
const FB_REDIRECT_URI = window.location.origin + '/';
const FB_LOGIN_CONFIG_ID = '2192704168290362';
const TIKTOK_CLIENT_KEY = 'awfha6z8vhwuyzsc';
const TIKTOK_REDIRECT_URI = window.location.origin + '/';
const REVIEWER_EMAIL = 'tiktok-reviewer@segurinidatalab.online';
const REVIEWER_SESSION_MAX_MS = 60 * 60 * 1000; // 60 minuti, poi logout forzato anche senza nuovo login

const supabaseAuth = createClient(SUPABASE_URL_NEW, SUPABASE_ANON_KEY);

const sbNew = async (path, opts = {}) => {
  const res = await fetch(`${SUPABASE_URL_NEW}/rest/v1/${path}`, {
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      Prefer: opts.prefer !== undefined ? opts.prefer : 'return=representation',
      ...opts.headers,
    },
    method: opts.method || 'GET',
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  const t = await res.text();
  return t ? JSON.parse(t) : [];
};

function Toast({ msg, onHide }) {
  useEffect(() => { if (msg) { const t = setTimeout(onHide, 2400); return () => clearTimeout(t); } }, [msg, onHide]);
  return <div className={`toast ${msg ? 'show' : ''}`}>{msg}</div>;
}
function Badge({ children, color = 'purple' }) {
  return <span className={`badge badge-${color}`}>{children}</span>;
}
function Toggle({ on, onChange }) {
  return <button className={`toggle ${on ? 'on' : ''}`} onClick={() => onChange(!on)}><span className="thumb" /></button>;
}
function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header"><span className="modal-title">{title}</span><button className="modal-close" onClick={onClose}><i className="ti ti-x" /></button></div>
        {children}
      </div>
    </div>
  );
}

const fieldStyle = {width:'100%',padding:'12px',borderRadius:'8px',border:'1px solid #333',background:'#0f1117',color:'white',fontSize:'14px',marginBottom:'12px',boxSizing:'border-box'};
const primaryBtnStyle = {width:'100%',padding:'12px',borderRadius:'8px',background:'linear-gradient(135deg,#667eea,#764ba2)',color:'white',fontSize:'15px',fontWeight:'600',border:'none',cursor:'pointer'};

function LoginScreen({ onLogin, externalError }) {
  const [mode, setMode] = useState('login'); // 'login' | 'forgot' | 'sent'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const shownError = error || externalError;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabaseAuth.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError('Email o password errati');
    else onLogin();
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (email.trim().toLowerCase() === REVIEWER_EMAIL) {
      setLoading(false);
      setMode('sent');
      return;
    }
    const { error } = await supabaseAuth.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + '/',
    });
    setLoading(false);
    if (error) setError('Errore: ' + error.message);
    else setMode('sent');
  };

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0f1117'}}>
      <div style={{background:'#1a1d27',padding:'40px',borderRadius:'16px',width:'360px',boxShadow:'0 8px 32px rgba(0,0,0,0.4)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <div style={{fontSize:'32px',marginBottom:'8px'}}>🧠</div>
          <h1 style={{color:'white',fontSize:'22px',fontWeight:'700',margin:0}}>MyManychat</h1>
          <p style={{color:'#888',fontSize:'14px',marginTop:'8px'}}>
            {mode === 'login' ? 'Accedi per continuare' : mode === 'forgot' ? 'Recupera la password' : 'Controlla la tua email'}
          </p>
        </div>

        {mode === 'login' && (
          <form onSubmit={handleSubmit}>
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} style={fieldStyle} />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} style={{...fieldStyle,marginBottom:'16px'}} />
            {shownError && <p style={{color:'#ff6b6b',fontSize:'13px',marginBottom:'12px'}}>{shownError}</p>}
            <button type="submit" disabled={loading} style={{...primaryBtnStyle,opacity:loading?0.7:1}}>
              {loading ? 'Accesso...' : 'Accedi'}
            </button>
            <p style={{textAlign:'center',fontSize:'13px',marginTop:'16px',marginBottom:0}}>
              <button type="button" onClick={() => { setMode('forgot'); setError(''); }} style={{background:'none',border:'none',color:'#888',cursor:'pointer',fontSize:'13px',textDecoration:'underline',padding:0}}>
                Password dimenticata?
              </button>
            </p>
          </form>
        )}

        {mode === 'forgot' && (
          <form onSubmit={handleForgot}>
            <p style={{color:'#888',fontSize:'13px',marginTop:0,marginBottom:'16px'}}>Inserisci la tua email: ti mandiamo un link per impostare una nuova password.</p>
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} style={{...fieldStyle,marginBottom:'16px'}} />
            {error && <p style={{color:'#ff6b6b',fontSize:'13px',marginBottom:'12px'}}>{error}</p>}
            <button type="submit" disabled={loading} style={{...primaryBtnStyle,opacity:loading?0.7:1}}>
              {loading ? 'Invio...' : 'Invia link di recupero'}
            </button>
            <p style={{textAlign:'center',fontSize:'13px',marginTop:'16px',marginBottom:0}}>
              <button type="button" onClick={() => { setMode('login'); setError(''); }} style={{background:'none',border:'none',color:'#888',cursor:'pointer',fontSize:'13px',textDecoration:'underline',padding:0}}>
                ← Torna al login
              </button>
            </p>
          </form>
        )}

        {mode === 'sent' && (
          <p style={{color:'#ccc',fontSize:'14px',textAlign:'center'}}>
            Se l'indirizzo esiste, a breve ricevi un'email con il link per reimpostare la password.
          </p>
        )}

        <p style={{textAlign:'center',fontSize:'12px',color:'#666',marginTop:'20px',marginBottom:0}}>
          <a href="/termini-e-condizioni.html" style={{color:'#888'}}>Termini e Condizioni</a>
          {' · '}
          <a href="/privacy-policy.html" style={{color:'#888'}}>Privacy Policy</a>
        </p>
      </div>
    </div>
  );
}

function ResetPasswordScreen({ onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('La password deve avere almeno 6 caratteri'); return; }
    if (password !== confirm) { setError('Le due password non coincidono'); return; }
    setLoading(true);
    const { error } = await supabaseAuth.auth.updateUser({ password });
    setLoading(false);
    if (error) setError('Errore: ' + error.message);
    else onDone();
  };

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0f1117'}}>
      <div style={{background:'#1a1d27',padding:'40px',borderRadius:'16px',width:'360px',boxShadow:'0 8px 32px rgba(0,0,0,0.4)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <div style={{fontSize:'32px',marginBottom:'8px'}}>🧠</div>
          <h1 style={{color:'white',fontSize:'22px',fontWeight:'700',margin:0}}>Nuova password</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <input type="password" placeholder="Nuova password" value={password} onChange={e => setPassword(e.target.value)} style={fieldStyle} />
          <input type="password" placeholder="Conferma password" value={confirm} onChange={e => setConfirm(e.target.value)} style={{...fieldStyle,marginBottom:'16px'}} />
          {error && <p style={{color:'#ff6b6b',fontSize:'13px',marginBottom:'12px'}}>{error}</p>}
          <button type="submit" disabled={loading} style={{...primaryBtnStyle,opacity:loading?0.7:1}}>
            {loading ? 'Salvataggio...' : 'Salva password'}
          </button>
        </form>
      </div>
    </div>
  );
}

function Posts({ toast }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [analyzing, setAnalyzing] = useState({});
  const [analyses, setAnalyses] = useState({});

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`https://graph.instagram.com/v19.0/${IG_USER_ID}/media?fields=id,caption,media_type,media_url,thumbnail_url,timestamp,like_count,comments_count,permalink&limit=20&access_token=${IG_TOKEN}`);
        const data = await res.json();
        setPosts(data.data || []);
      } catch (e) { toast('Errore caricamento post'); }
      setLoading(false);
    })();
  }, [toast]);

  const analyzeVideo = async (post) => {
    if (analyzing[post.id]) return;
    setAnalyzing(a => ({ ...a, [post.id]: true }));
    toast('Analisi video completo con Gemini in corso (fino a 40s)...');

    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/analyze-video-gemini`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ post_id: post.id, user_id: ANALYTICS_USER_ID }),
      });

      const data = await res.json();

      if (data.success) {
        setAnalyses(a => ({ ...a, [post.id]: data.analysis }));
        toast('✅ Analisi completata!');
      } else {
        toast('Errore: ' + (data.error || 'sconosciuto'));
      }
    } catch (e) {
      console.error(e);
      toast('Errore: ' + e.message);
    }

    setAnalyzing(a => ({ ...a, [post.id]: false }));
  };

  return (
    <div className="panel">
      <div className="panel-header"><h1><i className="ti ti-photo" /> Post Instagram</h1><Badge color="green">@neuroplasticity_training</Badge></div>
      {loading && <div className="posts-grid">{[...Array(9)].map((_, i) => <div key={i} className="post-skeleton" />)}</div>}
      <div className="posts-grid">
        {posts.map(p => (
          <div key={p.id} className={`post-card ${selected === p.id ? 'selected' : ''}`} onClick={() => setSelected(selected === p.id ? null : p.id)}>
            <div className="post-img-wrap">
              {p.media_type === 'VIDEO' ? <video src={p.media_url} className="post-img" muted /> : <img src={p.media_url || p.thumbnail_url} alt="" className="post-img" />}
              {p.media_type === 'VIDEO' && <div className="post-type-badge"><i className="ti ti-player-play" /></div>}
              {p.media_type === 'CAROUSEL_ALBUM' && <div className="post-type-badge"><i className="ti ti-stack-2" /></div>}
              <div className="post-overlay"><span><i className="ti ti-heart" /> {p.like_count || 0}</span><span><i className="ti ti-message-circle" /> {p.comments_count || 0}</span></div>
            </div>
            {selected === p.id && (
              <div className="post-detail">
                <p className="post-caption">{p.caption || 'Nessuna caption'}</p>
                <div className="post-meta-row">
                  <span className="post-date">{new Date(p.timestamp).toLocaleDateString('it')}</span>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <a href={p.permalink} target="_blank" rel="noreferrer" className="btn btn-sm"><i className="ti ti-external-link" /> Apri</a>
                    {p.media_type === 'VIDEO' && (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={e => { e.stopPropagation(); analyzeVideo(p); }}
                        disabled={analyzing[p.id]}
                        style={{ opacity: analyzing[p.id] ? 0.6 : 1 }}
                      >
                        {analyzing[p.id]
                          ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Analisi...</>
                          : <><i className="ti ti-scan" /> Analizza</>}
                      </button>
                    )}
                  </div>
                </div>

                {analyses[p.id] && (
                  <div style={{ marginTop: 12, borderTop: '1px solid var(--border)', paddingTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {analyses[p.id].summary && (
                      <div style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 1.5 }}>
                        <span style={{ color: 'var(--accent2)', fontWeight: 600 }}>📝 </span>
                        {analyses[p.id].summary}
                      </div>
                    )}
                    {analyses[p.id].scenes?.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)', width: '100%' }}>SCENE</span>
                        {analyses[p.id].scenes.map((s, i) => <span key={i} className="badge badge-purple">{s}</span>)}
                      </div>
                    )}
                    {analyses[p.id].objects?.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)', width: '100%' }}>OGGETTI</span>
                        {analyses[p.id].objects.map((tag, i) => (
                          <span key={i} className="badge badge-gray">{tag}</span>
                        ))}
                      </div>
                    )}
                    {analyses[p.id].colors?.length > 0 && (
                      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)' }}>COLORI</span>
                        {analyses[p.id].colors.map((c, i) => <span key={i} className="badge badge-amber">{c}</span>)}
                      </div>
                    )}
                    {analyses[p.id].text_detected?.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)', width: '100%' }}>TESTO NEL VIDEO</span>
                        {analyses[p.id].text_detected.map((t, i) => <span key={i} className="badge badge-green">{t}</span>)}
                      </div>
                    )}
                    {analyses[p.id].mood && (
                      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                        <span style={{ fontSize: 11, color: 'var(--text3)' }}>MOOD</span>
                        <span className="badge badge-pink">{analyses[p.id].mood}</span>
                        {analyses[p.id].content_type && <span className="badge badge-purple">{analyses[p.id].content_type}</span>}
                      </div>
                    )}
                    {analyses[p.id].hook_effectiveness && (
                      <div style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 1.5 }}>
                        <span style={{ color: 'var(--accent2)', fontWeight: 600 }}>🎯 Hook: </span>
                        {analyses[p.id].hook_effectiveness}
                      </div>
                    )}
                    {analyses[p.id].pacing_notes && (
                      <div style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 1.5 }}>
                        <span style={{ color: 'var(--accent2)', fontWeight: 600 }}>⏱️ Ritmo: </span>
                        {analyses[p.id].pacing_notes}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function Dashboard({ stats, posts }) {
  return (
    <div className="panel">
      <div className="panel-header"><h1>Dashboard</h1><Badge color="green"><i className="ti ti-circle-check" /> Live</Badge></div>
      <div className="stats-grid">
        {[['Messaggi','send','#7c6af7',stats.messages,'outbound DM'],['Lead','users','#4ade80',stats.leads,'da Instagram'],['Flow attivi','git-branch','#fbbf24',stats.flows,'automazioni'],['Keyword','tag','#f472b6',stats.keywords,'rispondono ai DM']].map(([label,icon,color,value,sub]) => (
          <div key={label} className="stat-card">
            <div className="stat-icon" style={{ background: color + '22', color }}><i className={`ti ti-${icon}`} /></div>
            <div><div className="stat-value">{value ?? '—'}</div><div className="stat-label">{label}</div><div className="stat-sub">{sub}</div></div>
          </div>
        ))}
      </div>
      <div className="two-col" style={{ gap: 16 }}>
        <div>
          <div className="section-title">Ultimi post</div>
          <div className="card">
            {!posts.length && <div className="empty">Caricamento post...</div>}
            {posts.slice(0, 4).map(p => (
              <div key={p.id} className="list-row">
                <img src={p.media_url || p.thumbnail_url} alt="" className="post-thumb" />
                <div className="list-info">
                  <span className="list-name">{(p.caption || 'Senza caption').slice(0, 50)}{(p.caption || '').length > 50 ? '…' : ''}</span>
                  <span className="list-meta"><i className="ti ti-heart" /> {p.like_count || 0} &nbsp;<i className="ti ti-message-circle" /> {p.comments_count || 0} &nbsp; {new Date(p.timestamp).toLocaleDateString('it')}</span>
                </div>
                <a href={p.permalink} target="_blank" rel="noreferrer" className="icon-btn"><i className="ti ti-external-link" /></a>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="section-title">Stato sistema</div>
          <div className="card">
            {[['Account','@neuroplasticity_training ✓'],['Webhook','ig-webhook ✓'],['Database','Supabase eu-west-1 ✓'],['AI Analysis','Claude Vision ✓']].map(([label, val]) => (
              <div key={label} className="config-row"><span className="config-label">{label}</span><span style={{ color: '#4ade80', fontSize: 13 }}>{val}</span></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Keywords({ toast }) {
  const [keywords, setKeywords] = useState([]);
  const [flows, setFlows] = useState([]);
  const [kw, setKw] = useState(''); const [reply, setReply] = useState(''); const [flowId, setFlowId] = useState('');
  const load = useCallback(async () => { const [k, f] = await Promise.all([sb('ig_keywords?select=*&order=created_at.desc'), sb('ig_flows?select=id,name&is_active=eq.true')]); setKeywords(k); setFlows(f); }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => { if (!kw || !reply) { toast('Inserisci keyword e risposta'); return; } try { await sb('ig_keywords', { method: 'POST', body: { user_id: ANALYTICS_USER_ID, keyword: kw.toLowerCase().trim(), reply_text: reply, flow_id: flowId || null, is_active: true } }); setKw(''); setReply(''); setFlowId(''); toast('Keyword aggiunta!'); load(); } catch (e) { toast('Errore: ' + e.message); } };
  const toggle = async (id, val) => { await sb(`ig_keywords?id=eq.${id}`, { method: 'PATCH', body: { is_active: val } }); load(); };
  const del = async (id) => { if (!window.confirm('Eliminare?')) return; await sb(`ig_keywords?id=eq.${id}`, { method: 'DELETE', prefer: '' }); toast('Eliminata'); load(); };
  return (
    <div className="panel">
      <div className="panel-header"><h1><i className="ti ti-tag" /> Parole chiave</h1></div>
      <div className="two-col">
        <div>
          <div className="section-title">Keyword attive ({keywords.length})</div>
          <div className="card list-card">
            {!keywords.length && <div className="empty">Nessuna keyword ancora</div>}
            {keywords.map(k => (
              <div key={k.id} className="list-row">
                <span className="kw-tag">{k.keyword}</span>
                <div className="list-info"><span className="list-meta" style={{ marginLeft: 8 }}>{k.reply_text}</span></div>
                <div className="list-actions"><Badge color={k.trigger_count > 0 ? 'purple' : 'gray'}>{k.trigger_count} trigger</Badge><Toggle on={k.is_active} onChange={v => toggle(k.id, v)} /><button className="icon-btn danger" onClick={() => del(k.id)}><i className="ti ti-trash" /></button></div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="section-title">Aggiungi keyword</div>
          <div className="card form-card">
            <div className="form-group"><label>Parola chiave</label><input value={kw} onChange={e => setKw(e.target.value)} placeholder="es. link, info, prezzo" /></div>
            <div className="form-group"><label>Risposta automatica DM</label><textarea value={reply} onChange={e => setReply(e.target.value)} placeholder="Ciao! Ecco le informazioni..." /></div>
            <div className="form-group"><label>Flow collegato</label><select value={flowId} onChange={e => setFlowId(e.target.value)}><option value="">Nessun flow</option>{flows.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}</select></div>
            <button className="btn btn-primary" onClick={save} style={{ width: '100%' }}><i className="ti ti-plus" /> Aggiungi</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Flows({ toast }) {
  const [flows, setFlows] = useState([]); const [modal, setModal] = useState(false); const [selected, setSelected] = useState(null);
  const [name, setName] = useState(''); const [triggerType, setTriggerType] = useState('keyword'); const [triggerValue, setTriggerValue] = useState(''); const [firstMsg, setFirstMsg] = useState('');
  const load = useCallback(async () => { const f = await sb('ig_flows?select=*&order=created_at.desc'); setFlows(f); }, []);
  useEffect(() => { load(); }, [load]);
  const create = async () => { if (!name) { toast('Inserisci il nome'); return; } const steps = firstMsg ? [{ type: 'message', message: firstMsg }] : []; await sb('ig_flows', { method: 'POST', body: { name, trigger_type: triggerType, trigger_value: triggerValue || null, steps, is_active: true } }); setModal(false); setName(''); setFirstMsg(''); setTriggerValue(''); toast('Flow creato!'); load(); };
  const toggle = async (id, val) => { await sb(`ig_flows?id=eq.${id}`, { method: 'PATCH', body: { is_active: val } }); load(); };
  const del = async (id) => { if (!window.confirm('Eliminare?')) return; await sb(`ig_flows?id=eq.${id}`, { method: 'DELETE', prefer: '' }); toast('Flow eliminato'); load(); };
  return (
    <div className="panel">
      <div className="panel-header"><h1><i className="ti ti-git-branch" /> Flow</h1><button className="btn btn-primary" onClick={() => setModal(true)}><i className="ti ti-plus" /> Nuovo flow</button></div>
      <div className="card list-card">
        {!flows.length && <div className="empty">Nessun flow ancora</div>}
        {flows.map(f => (
          <div key={f.id}>
            <div className="list-row flow-row" onClick={() => setSelected(selected === f.id ? null : f.id)}>
              <div className="flow-icon-wrap"><i className="ti ti-git-branch" /></div>
              <div className="list-info"><span className="list-name">{f.name}</span><span className="list-meta">Trigger: {f.trigger_type}{f.trigger_value ? ` → "${f.trigger_value}"` : ''} · {(f.steps || []).length} step · avviato {f.stats?.triggered || 0}×</span></div>
              <div className="list-actions"><Badge color={f.is_active ? 'green' : 'gray'}>{f.is_active ? 'Attivo' : 'Pausa'}</Badge><Toggle on={f.is_active} onChange={v => toggle(f.id, v)} /><button className="icon-btn danger" onClick={e => { e.stopPropagation(); del(f.id); }}><i className="ti ti-trash" /></button></div>
            </div>
            {selected === f.id && (
              <div className="flow-steps-wrap">
                {!(f.steps || []).length && <span style={{ color: 'var(--text3)', fontSize: 12 }}>Nessuno step</span>}
                {(f.steps || []).map((s, i) => <div key={i} className="step-pill"><span className="step-num">{i + 1}</span>{s.type === 'delay' ? <><i className="ti ti-clock" /> {s.delay_seconds}s</> : <><i className="ti ti-message" /> {s.message}</>}</div>)}
              </div>
            )}
          </div>
        ))}
      </div>
      <Modal open={modal} onClose={() => setModal(false)} title="Crea nuovo flow">
        <div className="modal-body">
          <div className="form-group"><label>Nome</label><input value={name} onChange={e => setName(e.target.value)} placeholder="es. Benvenuto follower" /></div>
          <div className="form-group"><label>Trigger</label><select value={triggerType} onChange={e => setTriggerType(e.target.value)}><option value="keyword">Parola chiave</option><option value="new_follower">Nuovo follower</option><option value="story_mention">Menzione storia</option><option value="comment">Commento</option></select></div>
          {triggerType === 'keyword' && <div className="form-group"><label>Parola chiave</label><input value={triggerValue} onChange={e => setTriggerValue(e.target.value)} placeholder="es. link" /></div>}
          <div className="form-group"><label>Primo messaggio</label><textarea value={firstMsg} onChange={e => setFirstMsg(e.target.value)} placeholder="Ciao! Grazie per averci scritto..." /></div>
        </div>
        <div className="modal-footer"><button className="btn" onClick={() => setModal(false)}>Annulla</button><button className="btn btn-primary" onClick={create}><i className="ti ti-check" /> Crea</button></div>
      </Modal>
    </div>
  );
}

function Leads({ toast }) {
  const [leads, setLeads] = useState([]);
  useEffect(() => { (async () => { const l = await sb('ig_leads?select=*&order=created_at.desc'); setLeads(l); })(); }, []);
  const exportCSV = () => { if (!leads.length) { toast('Nessun lead'); return; } const csv = ['ig_username,nome,email,telefono,source,data', ...leads.map(l => `${l.ig_username || ''},${l.name || ''},${l.email || ''},${l.phone || ''},${l.source || ''},${l.created_at}`)].join('\n'); const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv); a.download = 'ig_leads.csv'; a.click(); toast('CSV scaricato!'); };
  return (
    <div className="panel">
      <div className="panel-header"><h1><i className="ti ti-users" /> Lead <span className="count-badge">{leads.length}</span></h1><button className="btn" onClick={exportCSV}><i className="ti ti-download" /> Esporta CSV</button></div>
      <div className="card list-card">
        <div className="lead-header"><span>Utente</span><span>Email</span><span>Telefono</span><span>Fonte</span><span>Data</span></div>
        {!leads.length && <div className="empty">Nessun lead ancora</div>}
        {leads.map(l => <div key={l.id} className="lead-row"><div className="lead-name"><div className="avatar">{(l.ig_username || l.name || '?').slice(0, 2).toUpperCase()}</div><span>{l.ig_username ? '@' + l.ig_username : (l.name || '—')}</span></div><span className="lead-email">{l.email || '—'}</span><span className="lead-email">{l.phone || '—'}</span><Badge color="purple">{l.source || '—'}</Badge><span className="lead-date">{new Date(l.created_at).toLocaleDateString('it')}</span></div>)}
      </div>
    </div>
  );
}

function Config({ toast }) {
  const copy = t => { navigator.clipboard.writeText(t); toast('Copiato!'); };
  const [fbProfile, setFbProfile] = useState(null);
  const [loadingFb, setLoadingFb] = useState(true);
  const [tiktokProfile, setTiktokProfile] = useState(null);
  const [loadingTiktok, setLoadingTiktok] = useState(true);

  const loadFb = useCallback(async () => {
    try {
      const rows = await sbNew(`profiles?id=eq.${ANALYTICS_USER_ID}&select=fb_page_name,fb_page_id,fb_token_expires_at`);
      setFbProfile(rows?.[0] || null);
    } catch (e) { /* mostriamo comunque il bottone di collegamento */ }
    setLoadingFb(false);
  }, []);

  const loadTiktok = useCallback(async () => {
    try {
      const rows = await sbNew(`profiles?id=eq.${ANALYTICS_USER_ID}&select=tiktok_username,tiktok_open_id,tiktok_refresh_token_expires_at`);
      setTiktokProfile(rows?.[0] || null);
    } catch (e) { /* mostriamo comunque il bottone di collegamento */ }
    setLoadingTiktok(false);
  }, []);

  useEffect(() => { loadFb(); loadTiktok(); }, [loadFb, loadTiktok]);

  const connectFacebook = () => {
    const state = crypto.randomUUID();
    sessionStorage.setItem('fb_oauth_state', state);
    const url = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${FB_APP_ID}&redirect_uri=${encodeURIComponent(FB_REDIRECT_URI)}&state=${state}&config_id=${FB_LOGIN_CONFIG_ID}&response_type=code&auth_type=rerequest`;
    window.location.href = url;
  };

  const connectTiktok = () => {
    const state = crypto.randomUUID();
    sessionStorage.setItem('tiktok_oauth_state', state);
    const url = `https://www.tiktok.com/v2/auth/authorize/?client_key=${TIKTOK_CLIENT_KEY}&response_type=code&scope=user.info.basic,video.publish&redirect_uri=${encodeURIComponent(TIKTOK_REDIRECT_URI)}&state=${state}`;
    window.location.href = url;
  };

  const fbConnected = fbProfile?.fb_page_id;
  const fbExpiringSoon = fbProfile?.fb_token_expires_at && (new Date(fbProfile.fb_token_expires_at) - Date.now()) < 7 * 24 * 60 * 60 * 1000;
  const tiktokConnected = tiktokProfile?.tiktok_open_id;
  const tiktokExpiringSoon = tiktokProfile?.tiktok_refresh_token_expires_at && (new Date(tiktokProfile.tiktok_refresh_token_expires_at) - Date.now()) < 7 * 24 * 60 * 60 * 1000;

  return (
    <div className="panel">
      <div className="panel-header"><h1><i className="ti ti-settings" /> Configurazione</h1></div>
      <div className="section-title">Credenziali attive</div>
      <div className="card">
        {[['Account Instagram','@neuroplasticity_training ✓'],['App ID Meta','1314288600705533'],['Database','Supabase eu-west-1 ✓'],['AI Vision','Claude Opus ✓']].map(([label, val]) => <div key={label} className="config-row"><span className="config-label">{label}</span><span style={{ color: '#4ade80', fontSize: 13 }}>{val}</span></div>)}
      </div>
      <div className="section-title" style={{ marginTop: 20 }}>Pagina Facebook</div>
      <div className="card">
        {loadingFb && <div className="config-row"><span className="config-label">Stato</span><span style={{ fontSize: 13 }}>Caricamento...</span></div>}
        {!loadingFb && fbConnected && (
          <>
            <div className="config-row"><span className="config-label">Pagina collegata</span><span style={{ color: '#4ade80', fontSize: 13 }}>{fbProfile.fb_page_name} ✓</span></div>
            <div className="config-row"><span className="config-label">Page ID</span><span style={{ fontSize: 13 }}>{fbProfile.fb_page_id}</span></div>
            {fbExpiringSoon && (
              <div className="config-row">
                <span className="config-label" style={{ color: '#f59e0b' }}>Token in scadenza a breve</span>
                <button className="btn btn-sm" onClick={connectFacebook}>Ricollega</button>
              </div>
            )}
          </>
        )}
        {!loadingFb && !fbConnected && (
          <div className="config-row">
            <span className="config-label">Nessuna pagina collegata</span>
            <button className="btn btn-primary btn-sm" onClick={connectFacebook}>Collega Pagina Facebook</button>
          </div>
        )}
      </div>
      <div className="section-title" style={{ marginTop: 20 }}>TikTok</div>
      <div className="card">
        {loadingTiktok && <div className="config-row"><span className="config-label">Stato</span><span style={{ fontSize: 13 }}>Caricamento...</span></div>}
        {!loadingTiktok && tiktokConnected && (
          <>
            <div className="config-row"><span className="config-label">Account collegato</span><span style={{ color: '#4ade80', fontSize: 13 }}>{tiktokProfile.tiktok_username || tiktokProfile.tiktok_open_id} ✓</span></div>
            {tiktokExpiringSoon && (
              <div className="config-row">
                <span className="config-label" style={{ color: '#f59e0b' }}>Token in scadenza a breve</span>
                <button className="btn btn-sm" onClick={connectTiktok}>Ricollega</button>
              </div>
            )}
          </>
        )}
        {!loadingTiktok && !tiktokConnected && (
          <div className="config-row">
            <span className="config-label">Nessun account collegato</span>
            <button className="btn btn-primary btn-sm" onClick={connectTiktok}>Collega TikTok</button>
          </div>
        )}
      </div>
      <div className="section-title" style={{ marginTop: 20 }}>Webhook Meta</div>
      <div className="card">
        {[['Callback URL','https://yywcqmowpsejlunzoyli.supabase.co/functions/v1/ig-webhook'],['Verify Token','54861684-1a77-4a13-8718-f33af5a9ae66']].map(([label, val]) => (
          <div key={label} className="config-row"><span className="config-label">{label}</span><code className="mono-pill" style={{ flex: 1, cursor: 'pointer' }} onClick={() => copy(val)}>{val}</code><button className="icon-btn" onClick={() => copy(val)}><i className="ti ti-copy" /></button></div>
        ))}
      </div>
    </div>
  );
}

function CommentRules({ toast }) {
  const [rules, setRules] = useState([]);
  const [posts, setPosts] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [replyDm, setReplyDm] = useState('');
  const [replyComment, setReplyComment] = useState('');
  const [postId, setPostId] = useState('');

  const load = useCallback(async () => {
    const r = await sb('ig_comment_rules?select=*&order=created_at.desc');
    setRules(r);
    try {
      const res = await fetch(`https://graph.instagram.com/v19.0/${IG_USER_ID}/media?fields=id,caption&limit=10&access_token=${IG_TOKEN}`);
      const data = await res.json();
      setPosts(data.data || []);
    } catch(e) {}
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!replyDm) { toast('Inserisci il messaggio DM'); return; }
    await sb('ig_comment_rules', { method: 'POST', body: { keyword: keyword.toLowerCase().trim() || null, reply_dm: replyDm, reply_comment: replyComment || null, post_id: postId || null, is_active: true } });
    setKeyword(''); setReplyDm(''); setReplyComment(''); setPostId('');
    toast('Regola aggiunta!'); load();
  };

  const toggle = async (id, val) => { await sb(`ig_comment_rules?id=eq.${id}`, { method: 'PATCH', body: { is_active: val } }); load(); };
  const del = async (id) => { if (!window.confirm('Eliminare?')) return; await sb(`ig_comment_rules?id=eq.${id}`, { method: 'DELETE', prefer: '' }); toast('Eliminata'); load(); };

  return (
    <div className="panel">
      <div className="panel-header">
        <h1><i className="ti ti-message-forward" /> Auto-DM da commenti</h1>
        <span className="badge badge-green"><i className="ti ti-bolt" /> Attivo</span>
      </div>
      <div className="info-box">
        <i className="ti ti-info-circle" />
        <span>Quando qualcuno commenta un tuo post con una parola chiave, riceve automaticamente un DM privato.</span>
      </div>
      <div className="two-col">
        <div>
          <div className="section-title">Regole attive ({rules.length})</div>
          <div className="card list-card">
            {!rules.length && <div className="empty">Nessuna regola ancora</div>}
            {rules.map(r => (
              <div key={r.id} className="list-row">
                <div className="flow-icon-wrap" style={{ background: '#f472b622', color: '#f472b6' }}><i className="ti ti-message-forward" /></div>
                <div className="list-info">
                  <span className="list-name">{r.keyword ? `Keyword: "${r.keyword}"` : 'Qualsiasi commento'}</span>
                  <span className="list-meta">DM: {r.reply_dm} {r.post_id ? '· Post specifico' : '· Tutti i post'}</span>
                  <span className="list-meta" style={{color:'var(--accent2)'}}>{r.trigger_count} trigger</span>
                </div>
                <div className="list-actions">
                  <Toggle on={r.is_active} onChange={v => toggle(r.id, v)} />
                  <button className="icon-btn danger" onClick={() => del(r.id)}><i className="ti ti-trash" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="section-title">Nuova regola</div>
          <div className="card form-card">
            <div className="form-group">
              <label>Parola chiave nel commento (opzionale)</label>
              <input value={keyword} onChange={e => setKeyword(e.target.value)} placeholder="es. link, info — vuoto = tutti i commenti" />
            </div>
            <div className="form-group">
              <label>Post specifico (opzionale)</label>
              <select value={postId} onChange={e => setPostId(e.target.value)}>
                <option value="">Tutti i post</option>
                {posts.map(p => <option key={p.id} value={p.id}>{(p.caption || 'Post senza caption').slice(0, 40)}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Messaggio DM automatico</label>
              <textarea value={replyDm} onChange={e => setReplyDm(e.target.value)} placeholder="Ciao! Grazie per il commento, ecco il link che cercavi..." />
            </div>
            <div className="form-group">
              <label>Risposta pubblica al commento (opzionale)</label>
              <input value={replyComment} onChange={e => setReplyComment(e.target.value)} placeholder="es. Ti ho mandato un DM!" />
            </div>
            <button className="btn btn-primary" onClick={save} style={{ width: '100%' }}><i className="ti ti-plus" /> Aggiungi regola</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function BozzeVirali({ toast }) {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncProgress, setSyncProgress] = useState(null);
  const [publishing, setPublishing] = useState({});
  const [publishingFb, setPublishingFb] = useState({});
  const [publishingTiktok, setPublishingTiktok] = useState({});
  const [edits, setEdits] = useState({});

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await sbNew(`editorial_posts?user_id=eq.${ANALYTICS_USER_ID}&generated_image_url=not.is.null&order=created_at.desc`);
      setDrafts(d);
    } catch (e) { toast('Errore caricamento bozze'); }
    setLoading(false);
  }, [toast]);

  useEffect(() => { load(); }, [load]);

  const STEP_LABELS = {
    starting: 'Avvio...',
    fetching_media: 'Scarico i post da Instagram...',
    analyzing_insights: 'Analizzo le metriche',
    analyzing_video: 'Analizzo i Reel con Gemini',
    building_profile: 'Claude costruisce il profilo virale...',
    generating_plan: 'Claude scrive il piano editoriale...',
    done: 'Completato!',
    error: 'Errore',
  };

  const syncAnalytics = async () => {
    setSyncing(true);
    setSyncProgress(null);
    let polling = true;
    const poll = async () => {
      while (polling) {
        try {
          const rows = await sbNew(`sync_progress?user_id=eq.${ANALYTICS_USER_ID}&select=*`);
          if (rows?.[0]) setSyncProgress(rows[0]);
        } catch {}
        await new Promise(r => setTimeout(r, 1500));
      }
    };
    poll();
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/content-intelligence`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID }),
      });
      const data = await res.json();
      if (data.debug_insights_sample) window.alert(JSON.stringify(data.debug_insights_sample, null, 2));
      if (data.error) toast('Errore sync: ' + data.error);
      else toast(`✅ Analizzati ${data.videos_analyzed ?? 0} post. Ora puoi generare le bozze.`);
    } catch (e) { toast('Errore sync: ' + e.message); }
    polling = false;
    setSyncing(false);
    setSyncProgress(null);
  };


  const [lastError, setLastError] = useState(null);
  const [scheduleAt, setScheduleAt] = useState({});

  const [refImage, setRefImage] = useState(null);
  const [refTopic, setRefTopic] = useState('');
  const [refGenerating, setRefGenerating] = useState(false);

  const generateFromReference = async () => {
    if (!refImage || !refTopic.trim()) { toast('Carica un\'immagine e scrivi un topic'); return; }
    setRefGenerating(true);
    try {
      const fileName = `${ANALYTICS_USER_ID}/ref-${Date.now()}-${refImage.name}`;
      const uploadRes = await fetch(`${SUPABASE_URL_NEW}/storage/v1/object/reference-images/${fileName}`, {
        method: 'POST',
        headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': refImage.type },
        body: refImage,
      });
      if (!uploadRes.ok) throw new Error('Upload immagine fallito: ' + await uploadRes.text());
      const referenceImageUrl = `${SUPABASE_URL_NEW}/storage/v1/object/public/reference-images/${fileName}`;

      toast('Generazione in corso, può richiedere fino a 30-40 secondi...');
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/generate-draft-from-reference`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID, reference_image_url: referenceImageUrl, topic: refTopic.trim() }),
      });
      const data = await res.json();
      if (data.error) toast('Errore: ' + data.error);
      else { toast('✅ Bozza creata dal riferimento!'); setRefImage(null); setRefTopic(''); load(); }
    } catch (e) { toast('Errore: ' + e.message); }
    setRefGenerating(false);
  };

  const saveEdits = async (id) => {
    const edit = edits[id];
    if (!edit) return;
    try {
      await sbNew(`editorial_posts?id=eq.${id}`, { method: 'PATCH', prefer: 'return=minimal', body: edit });
      toast('✅ Modifiche salvate');
      setEdits(e => { const n = { ...e }; delete n[id]; return n; });
      load();
    } catch (e) { toast('Errore: ' + e.message); }
  };

  const schedule = async (id) => {
    const when = scheduleAt[id];
    if (!when) { toast('Scegli prima data e ora'); return; }
    try {
      await sbNew(`editorial_posts?id=eq.${id}`, {
        method: 'PATCH',
        prefer: 'return=minimal',
        body: { status: 'scheduled', scheduled_for: new Date(when).toISOString() },
      });
      toast('📅 Programmata!');
      load();
    } catch (e) { toast('Errore: ' + e.message); }
  };

  const unschedule = async (id) => {
    try {
      await sbNew(`editorial_posts?id=eq.${id}`, {
        method: 'PATCH',
        prefer: 'return=minimal',
        body: { status: 'draft_ready', scheduled_for: null },
      });
      toast('Programmazione annullata');
      load();
    } catch (e) { toast('Errore: ' + e.message); }
  };

  const generate = async () => {
    setGenerating(true);
    toast('Generazione bozze in corso, può richiedere un minuto...');
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/generate-viral-drafts`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID }),
      });
      const data = await res.json();
      setLastError(JSON.stringify(data, null, 2));
      if (data.error) toast('Errore: ' + data.error);
      else toast(`✅ ${data.drafts_created || 0} nuove bozze generate!`);
    } catch (e) { setLastError('Errore di rete: ' + e.message); toast('Errore: ' + e.message); }
    setGenerating(false);
    load();
  };

  const publish = async (id) => {
    setPublishing(p => ({ ...p, [id]: true }));
    const edit = edits[id];
    try {
      if (edit) await sbNew(`editorial_posts?id=eq.${id}`, { method: 'PATCH', body: edit, prefer: 'return=minimal' });
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/publish-draft`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ draft_id: id }),
      });
      const data = await res.json();
      if (data.error) toast('Errore pubblicazione: ' + data.error);
      else toast('✅ Pubblicato su Instagram!');
    } catch (e) { toast('Errore: ' + e.message); }
    setPublishing(p => ({ ...p, [id]: false }));
    load();
  };

  const publishFb = async (id) => {
    setPublishingFb(p => ({ ...p, [id]: true }));
    const edit = edits[id];
    try {
      if (edit) await sbNew(`editorial_posts?id=eq.${id}`, { method: 'PATCH', body: edit, prefer: 'return=minimal' });
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/publish-draft-fb`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ draft_id: id }),
      });
      const data = await res.json();
      if (data.error) toast('Errore pubblicazione Facebook: ' + data.error);
      else toast('✅ Pubblicato su Facebook!');
    } catch (e) { toast('Errore: ' + e.message); }
    setPublishingFb(p => ({ ...p, [id]: false }));
    load();
  };

  const publishTiktok = async (id) => {
    setPublishingTiktok(p => ({ ...p, [id]: true }));
    const edit = edits[id];
    try {
      if (edit) await sbNew(`editorial_posts?id=eq.${id}`, { method: 'PATCH', body: edit, prefer: 'return=minimal' });
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/publish-draft-tiktok`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ draft_id: id }),
      });
      const data = await res.json();
      if (data.error) toast('Errore pubblicazione TikTok: ' + data.error);
      else toast('✅ Pubblicato su TikTok!');
    } catch (e) { toast('Errore: ' + e.message); }
    setPublishingTiktok(p => ({ ...p, [id]: false }));
    load();
  };

  const discard = async (id) => {
    if (!window.confirm('Scartare questa bozza?')) return;
    try {
      await sbNew(`editorial_posts?id=eq.${id}`, { method: 'DELETE', prefer: '' });
      toast('Bozza scartata');
      setDrafts(d => d.filter(x => x.id !== id));
    } catch (e) { toast('Errore: ' + e.message); }
  };

  const setEdit = (id, field, value) => setEdits(e => ({ ...e, [id]: { ...e[id], [field]: value } }));
  const val = (d, field) => (edits[d.id]?.[field] !== undefined ? edits[d.id][field] : d[field]);

  const statusBadge = (status) => {
    const map = { draft_ready: ['Pronta', 'purple'], scheduled: ['Programmata', 'amber'], publishing: ['Pubblicazione...', 'amber'], published: ['Pubblicata', 'green'], failed: ['Errore', 'pink'] };
    const [label, color] = map[status] || [status, 'gray'];
    return <Badge color={color}>{label}</Badge>;
  };

  return (
    <div className="panel">
      <style>{`
        .draft-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:16px}
        .draft-card{background:var(--bg2);border:1px solid var(--border);border-radius:8px;overflow:hidden;display:flex;flex-direction:column}
        .draft-img-wrap{position:relative;padding-bottom:125%;overflow:hidden;background:var(--bg3)}
        .draft-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
        .draft-body{padding:14px;display:flex;flex-direction:column;gap:8px}
        .draft-topic{font-size:14px;font-weight:600;color:var(--text)}
        .draft-why{font-size:11px;color:var(--text3);font-style:italic}
        .draft-error{font-size:11px;color:var(--red)}
        .draft-score{font-size:11px;color:var(--text3)}
        .draft-row{display:flex;align-items:center;justify-content:space-between}
        .draft-actions{display:flex;gap:6px;margin-top:4px}
      `}</style>
      <div className="panel-header">
        <h1><i className="ti ti-sparkles" /> Bozze virali</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn" onClick={syncAnalytics} disabled={syncing}>
            {syncing
              ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Sincronizzazione...</>
              : <><i className="ti ti-refresh" /> Aggiorna analytics da Instagram</>}
          </button>
          <button className="btn btn-primary" onClick={generate} disabled={generating}>
            {generating
              ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Generazione...</>
              : <><i className="ti ti-wand" /> Genera nuove bozze ora</>}
          </button>
        </div>
      </div>
      <div className="info-box">
        <i className="ti ti-info-circle" />
        <span>Prima volta? Premi "Aggiorna analytics da Instagram" (scarica i dati reali di reach/saves dai tuoi post), poi "Genera nuove bozze ora". Da qui in poi succede tutto in automatico ogni lunedì.</span>
      </div>
      {syncing && syncProgress && (
        <div className="info-box" style={{ background: 'rgba(99,102,241,0.12)', borderColor: 'var(--accent2)' }}>
          <i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite', color: 'var(--accent2)' }} />
          <span>
            {STEP_LABELS[syncProgress.step] || syncProgress.step}
            {syncProgress.total_items > 0 && ` (${syncProgress.current_item}/${syncProgress.total_items})`}
            {syncProgress.detail ? ` — ${syncProgress.detail}` : ''}
          </span>
        </div>
      )}
      <div className="info-box" style={{ background: 'rgba(168,85,247,0.1)', borderColor: '#a855f7', display: 'block' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <i className="ti ti-photo-up" style={{ color: '#a855f7' }} />
          <strong>Crea da immagine di riferimento</strong>
        </div>
        <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10 }}>
          Carica un'immagine che è andata virale (tua o di altri) e scrivi un nuovo argomento: il sistema genera una nuova immagine ispirata allo stesso stile, più caption e CTA.
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <input type="file" accept="image/*" onChange={e => setRefImage(e.target.files?.[0] || null)} style={{ fontSize: 12 }} />
          <input
            type="text"
            placeholder="Nuovo argomento (es. ansia da prestazione)"
            value={refTopic}
            onChange={e => setRefTopic(e.target.value)}
            style={{ flex: 1, minWidth: 200, padding: 8, borderRadius: 6, border: '1px solid var(--border)' }}
          />
          <button className="btn btn-primary btn-sm" onClick={generateFromReference} disabled={refGenerating}>
            {refGenerating ? 'Generazione...' : 'Genera bozza'}
          </button>
        </div>
      </div>
      {lastError && (
        <div className="info-box" style={{ background: 'rgba(248,113,113,0.12)', borderColor: 'var(--red)', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12, maxHeight: 300, overflow: 'auto' }}>
          <i className="ti ti-alert-triangle" style={{ color: 'var(--red)' }} />
          <span>{lastError}</span>
        </div>
      )}
      {loading && <div className="empty">Caricamento...</div>}
      {!loading && !drafts.length && <div className="empty">Nessuna bozza ancora. Premi "Genera nuove bozze ora" per crearne subito.</div>}
      <div className="draft-grid">
        {drafts.map(d => (
          <div key={d.id} className="draft-card">
            <div className="draft-img-wrap"><img src={d.generated_image_url} alt={d.topic} className="draft-img" /></div>
            <div className="draft-body">
              <div className="draft-row">
                {statusBadge(d.status)}
                {d.audience_growth_score != null && <span className="draft-score">score {Number(d.audience_growth_score).toFixed(2)}</span>}
              </div>
              <span className="draft-topic">{d.topic}</span>
              <div className="form-group">
                <label>Caption</label>
                <textarea value={val(d, 'caption_suggestion') || ''} onChange={e => setEdit(d.id, 'caption_suggestion', e.target.value)} disabled={d.status === 'published'} rows={4} />
              </div>
              <div className="form-group">
                <label>Call to action</label>
                <input value={val(d, 'cta_suggestion') || ''} onChange={e => setEdit(d.id, 'cta_suggestion', e.target.value)} disabled={d.status === 'published'} />
              </div>
              {d.why_suggested && <p className="draft-why">{d.why_suggested}</p>}
              {d.status === 'failed' && d.publish_error && <p className="draft-error">IG: {d.publish_error}</p>}
              {d.fb_status === 'failed' && d.fb_publish_error && <p className="draft-error">FB: {d.fb_publish_error}</p>}
              {d.tiktok_status === 'failed' && d.tiktok_publish_error && <p className="draft-error">TikTok: {d.tiktok_publish_error}</p>}
              {d.status === 'scheduled' && d.scheduled_for && (
                <p className="draft-score">Programmata per: {new Date(d.scheduled_for).toLocaleString('it-IT')}</p>
              )}
              {(d.status === 'draft_ready' || d.status === 'failed') && (
                <div className="form-group">
                  <label>Programma per</label>
                  <input
                    type="datetime-local"
                    value={scheduleAt[d.id] || ''}
                    onChange={e => setScheduleAt(s => ({ ...s, [d.id]: e.target.value }))}
                  />
                </div>
              )}
              {d.status !== 'published' && d.status !== 'scheduled' && (
                <div className="draft-actions">
                  <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={() => publish(d.id)} disabled={publishing[d.id] || d.status === 'publishing'}>
                    {publishing[d.id] || d.status === 'publishing' ? 'Pubblicazione...' : 'Pubblica su Instagram'}
                  </button>
                  <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => schedule(d.id)}>Programma</button>
                  <button className="icon-btn danger" onClick={() => discard(d.id)}><i className="ti ti-trash" /></button>
                </div>
              )}
              {d.fb_status !== 'published' && (
                <div className="draft-actions">
                  <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => publishFb(d.id)} disabled={publishingFb[d.id] || d.fb_status === 'publishing'}>
                    {publishingFb[d.id] || d.fb_status === 'publishing' ? 'Pubblicazione...' : 'Pubblica su Facebook'}
                  </button>
                </div>
              )}
              {d.tiktok_status !== 'published' && (
                <div className="draft-actions">
                  <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => publishTiktok(d.id)} disabled={publishingTiktok[d.id] || d.tiktok_status === 'publishing'}>
                    {publishingTiktok[d.id] || d.tiktok_status === 'publishing' ? 'Pubblicazione...' : 'Pubblica su TikTok'}
                  </button>
                </div>
              )}
              {d.status === 'scheduled' && (
                <div className="draft-actions">
                  <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => saveEdits(d.id)} disabled={!edits[d.id]}>Salva modifiche</button>
                  <button className="btn btn-sm" style={{ flex: 1 }} onClick={() => unschedule(d.id)}>Annulla programmazione</button>
                  <button className="icon-btn danger" onClick={() => discard(d.id)}><i className="ti ti-trash" /></button>
                </div>
              )}
              {d.status === 'published' && d.published_media_id && <span className="draft-score">IG media ID: {d.published_media_id}</span>}
              {d.fb_status === 'published' && d.fb_post_id && <span className="draft-score">FB post ID: {d.fb_post_id}</span>}
              {d.tiktok_status === 'published' && d.tiktok_publish_id && <span className="draft-score">TikTok publish ID: {d.tiktok_publish_id}</span>}
              {(d.resource_pdf_url || d.stripe_payment_link) && (
                <div className="draft-row" style={{ marginTop: 6, gap: 10 }}>
                  {d.resource_pdf_url && <a href={d.resource_pdf_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: 'var(--accent2)' }}>📄 Vedi PDF guida</a>}
                  {d.stripe_payment_link && <a href={d.stripe_payment_link} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: 'var(--accent2)' }}>💳 Link pagamento</a>}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Performance({ toast }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadReport = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/effectiveness-report`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID }),
      });
      const data = await res.json();
      if (data.error) toast('Errore: ' + data.error);
      else setReport(data);
    } catch (e) { toast('Errore: ' + e.message); }
    setLoading(false);
  }, [toast]);

  useEffect(() => { loadReport(); }, [loadReport]);

  const diffPct = (sys, base) => {
    if (!base) return null;
    const pct = ((sys - base) / base) * 100;
    return pct;
  };

  const StatDiff = ({ label, sys, base, suffix = '' }) => {
    const pct = diffPct(sys, base);
    const positive = pct != null && pct >= 0;
    return (
      <div className="form-group" style={{ marginBottom: 4 }}>
        <label>{label}</label>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
          <span style={{ fontSize: 20, fontWeight: 700 }}>{sys}{suffix}</span>
          <span style={{ fontSize: 12, color: 'var(--text3)' }}>vs storico {base}{suffix}</span>
          {pct != null && (
            <span style={{ fontSize: 12, fontWeight: 600, color: positive ? '#22c55e' : '#f87171' }}>
              {positive ? '▲' : '▼'} {Math.abs(pct).toFixed(0)}%
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="panel">
      <div className="panel-header">
        <h1><i className="ti ti-chart-line" /> Performance del sistema</h1>
        <button className="btn" onClick={loadReport} disabled={loading}>
          {loading ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Aggiorno...</> : <><i className="ti ti-refresh" /> Aggiorna report</>}
        </button>
      </div>
      <div className="info-box">
        <i className="ti ti-info-circle" />
        <span>Confronta i post generati automaticamente dal sistema con lo storico precedente, e mostra il funnel reale (commenti → DM → pagamenti Stripe).</span>
      </div>

      {!report && !loading && <div className="empty">Nessun dato ancora.</div>}

      {report && (
        <>
          <div className="draft-grid" style={{ marginBottom: 24 }}>
            <div className="draft-card" style={{ padding: 16 }}>
              <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Contenuto — sistema vs storico</span>
              <StatDiff label="Reach medio" sys={report.contenuto.sistema.avg_reach} base={report.contenuto.storico_precedente.avg_reach} />
              <StatDiff label="Saves medi" sys={report.contenuto.sistema.avg_saves} base={report.contenuto.storico_precedente.avg_saves} />
              <StatDiff label="Engagement rate" sys={(report.contenuto.sistema.avg_engagement_rate * 100).toFixed(2)} base={(report.contenuto.storico_precedente.avg_engagement_rate * 100).toFixed(2)} suffix="%" />
              <p className="draft-score" style={{ marginTop: 10 }}>
                Basato su {report.contenuto.sistema.post_pubblicati} post del sistema vs {report.contenuto.storico_precedente.post_totali} storici.
                {report.contenuto.sistema.post_pubblicati < 10 && ' Campione ancora piccolo: i numeri si stabilizzano con più post pubblicati.'}
              </p>
            </div>
            <div className="draft-card" style={{ padding: 16 }}>
              <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Funnel di monetizzazione</span>
              <div className="form-group"><label>Guide create</label><span style={{ fontSize: 20, fontWeight: 700 }}>{report.funnel.guide_create}</span></div>
              <div className="form-group"><label>DM inviati da keyword</label><span style={{ fontSize: 20, fontWeight: 700 }}>{report.funnel.dm_inviati_da_keyword}</span></div>
              <div className="form-group">
                <label>Pagamenti completati</label>
                {report.funnel.stripe_errore
                  ? <p className="draft-error">{report.funnel.stripe_errore}</p>
                  : <span style={{ fontSize: 20, fontWeight: 700 }}>{report.funnel.pagamenti_completati} — €{report.funnel.fatturato_euro.toFixed(2)}</span>}
              </div>
            </div>
            {report.benchmark_concorrenti && (
              <div className="draft-card" style={{ padding: 16 }}>
                <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Benchmark vs concorrenti</span>
                <div className="form-group" style={{ marginBottom: 10 }}>
                  <label>Tu</label>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                    <span style={{ fontSize: 18, fontWeight: 700 }}>{(report.benchmark_concorrenti.tu.followers ?? 0).toLocaleString('it-IT')} follower</span>
                    {report.benchmark_concorrenti.tu.growth_giornaliero_medio != null && (
                      <span style={{ fontSize: 12, color: 'var(--text3)' }}>{report.benchmark_concorrenti.tu.growth_giornaliero_medio >= 0 ? '+' : ''}{report.benchmark_concorrenti.tu.growth_giornaliero_medio}/giorno</span>
                    )}
                  </div>
                </div>
                {report.benchmark_concorrenti.concorrenti.map(c => (
                  <div key={c.username} className="form-group" style={{ marginBottom: 6 }}>
                    <label>@{c.username}</label>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 14, fontWeight: 600 }}>{(c.followers ?? 0).toLocaleString('it-IT')} follower</span>
                      {c.growth_giornaliero_medio != null && <span style={{ fontSize: 11, color: 'var(--text3)' }}>{c.growth_giornaliero_medio >= 0 ? '+' : ''}{c.growth_giornaliero_medio}/giorno</span>}
                      {c.engagement_rate_stimato_top_post != null && <span style={{ fontSize: 11, color: 'var(--accent2)' }}>ER stimato top post: {(c.engagement_rate_stimato_top_post * 100).toFixed(1)}%</span>}
                    </div>
                  </div>
                ))}
                <p className="draft-score" style={{ marginTop: 8 }}>La crescita concorrenti appare dopo qualche giorno di raccolta dati (parte automaticamente ogni giorno). L'ER stimato usa like+commenti sui loro post più virali / follower attuali — non è un vero ER (non abbiamo il reach), quindi può superare il 100% su post diventati virali oltre la loro base follower.</p>
              </div>
            )}

          </div>
          <p className="draft-score">Generato: {new Date(report.generated_at).toLocaleString('it-IT')}</p>
        </>
      )}
    </div>
  );
}

function MiniLineChart({ data, color = 'var(--accent2)', height = 140 }) {
  if (!data || data.length < 2) return <div className="empty" style={{ padding: 20 }}>Dati insufficienti per il grafico</div>;
  const width = 600;
  const values = data.map(d => d.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const pad = 8;
  const points = data.map((d, i) => {
    const x = pad + (i / (data.length - 1)) * (width - pad * 2);
    const y = pad + (1 - (d.value - min) / range) * (height - pad * 2);
    return `${x},${y}`;
  });
  const pathD = 'M' + points.join(' L');
  const areaD = `${pathD} L${width - pad},${height - pad} L${pad},${height - pad} Z`;
  const gradId = 'followerFillGrad';
  return (
    <svg viewBox={`0 0 ${width} ${height}`} style={{ width: '100%', height, display: 'block' }} preserveAspectRatio="none">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.28" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={areaD} fill={`url(#${gradId})`} stroke="none" />
      <path d={pathD} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

const DAY_NAMES = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
const num = v => (v === null || v === undefined ? null : Number(v));

function CompetitorComparison({ toast, myFollowers }) {
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await sbNew(`competitor_snapshots?user_id=eq.${ANALYTICS_USER_ID}&select=*&order=snapshot_date.asc`);
      setSnapshots(d || []);
    } catch (e) { toast('Errore caricamento concorrenti: ' + e.message); }
    setLoading(false);
  }, [toast]);

  useEffect(() => { load(); }, [load]);

  const refresh = async () => {
    setRefreshing(true);
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/capture-competitor-snapshot`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID }),
      });
      const data = await res.json();
      if (data.error) toast('Errore: ' + data.error);
      else toast('✅ Dati concorrenti aggiornati');
    } catch (e) { toast('Errore: ' + e.message); }
    setRefreshing(false);
    load();
  };

  if (loading) return null;

  // group by competitor, keep latest + first snapshot
  const byCompetitor = {};
  for (const s of snapshots) {
    if (!byCompetitor[s.competitor_username]) byCompetitor[s.competitor_username] = [];
    byCompetitor[s.competitor_username].push(s);
  }
  const competitors = Object.keys(byCompetitor).map(username => {
    const rows = byCompetitor[username];
    const latest = rows[rows.length - 1];
    const first = rows[0];
    const growth = rows.length > 1 ? latest.followers_count - first.followers_count : null;
    return { username, latest, first, growth, days: rows.length };
  }).sort((a, b) => (b.latest.followers_count || 0) - (a.latest.followers_count || 0));

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="draft-row" style={{ marginBottom: 10 }}>
        <span className="section-title" style={{ marginBottom: 0 }}>Confronto con i concorrenti</span>
        <button className="btn btn-sm" onClick={refresh} disabled={refreshing}>
          {refreshing ? 'Aggiorno...' : <><i className="ti ti-refresh" /> Aggiorna concorrenti</>}
        </button>
      </div>

      {!competitors.length && <div className="empty">Nessun dato concorrenti ancora. Premi "Aggiorna concorrenti".</div>}

      {!!competitors.length && (
        <div className="draft-grid">
          {myFollowers != null && (
            <div className="draft-card" style={{ padding: 16, borderColor: 'var(--accent)' }}>
              <span className="draft-topic">Tu (@neuroplasticity_training)</span>
              <div style={{ fontSize: 24, fontWeight: 700, marginTop: 6 }}>{myFollowers.toLocaleString('it-IT')}</div>
              <span className="draft-score">follower</span>
            </div>
          )}
          {competitors.map(c => (
            <div key={c.username} className="draft-card" style={{ padding: 16 }}>
              <span className="draft-topic">@{c.username}</span>
              {c.latest.competitor_full_name && <div className="draft-score" style={{ marginBottom: 6 }}>{c.latest.competitor_full_name}</div>}
              <div style={{ fontSize: 24, fontWeight: 700, marginTop: 6 }}>{(c.latest.followers_count ?? 0).toLocaleString('it-IT')}</div>
              <span className="draft-score">follower</span>
              {c.growth !== null && (
                <div style={{ marginTop: 8 }}>
                  <Badge color={c.growth >= 0 ? 'green' : 'pink'}>
                    {c.growth >= 0 ? '▲' : '▼'} {c.growth >= 0 ? '+' : ''}{c.growth} su {c.days} giorni
                  </Badge>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function TopCompetitorPosts({ toast }) {
  const [posts, setPosts] = useState([]);
  const [videoAnalysis, setVideoAnalysis] = useState({});
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [d, va] = await Promise.all([
        sbNew(`competitor_top_posts?user_id=eq.${ANALYTICS_USER_ID}&select=*&order=engagement_score.desc`),
        sbNew(`competitor_video_analysis?user_id=eq.${ANALYTICS_USER_ID}&status=eq.done&select=*`),
      ]);
      setPosts(d || []);
      const map = {};
      (va || []).forEach(a => { map[a.media_pk] = a; });
      setVideoAnalysis(map);
    } catch (e) { toast('Errore caricamento post concorrenti: ' + e.message); }
    setLoading(false);
  }, [toast]);


  useEffect(() => { load(); }, [load]);

  const refresh = async () => {
    setRefreshing(true);
    toast('Analisi post concorrenti in corso, può richiedere fino a 20 secondi...');
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/capture-competitor-top-posts`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID, top_n: 5 }),
      });
      const data = await res.json();
      if (data.error) toast('Errore: ' + data.error);
      else toast('✅ Post concorrenti aggiornati');
    } catch (e) { toast('Errore: ' + e.message); }
    setRefreshing(false);
    load();
  };

  const analyzeVideos = async () => {
    setAnalyzing(true);
    toast('Analisi Reel in corso con Gemini, può richiedere fino a 2 minuti...');
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/analyze-competitor-videos`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID, per_competitor: 2 }),
      });
      const data = await res.json();
      if (data.error) toast('Errore: ' + data.error);
      else toast('✅ Analisi Reel completata');
    } catch (e) { toast('Errore: ' + e.message); }
    setAnalyzing(false);
    load();
  };

  if (loading) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="draft-row" style={{ marginBottom: 10 }}>
        <span className="section-title" style={{ marginBottom: 0 }}>Reel/post più virali dei concorrenti</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-sm" onClick={refresh} disabled={refreshing}>
            {refreshing ? 'Analisi...' : <><i className="ti ti-refresh" /> Aggiorna</>}
          </button>
          <button className="btn btn-sm" onClick={analyzeVideos} disabled={analyzing}>
            {analyzing ? 'Analisi...' : <><i className="ti ti-video" /> Analizza Reel</>}
          </button>
        </div>
      </div>

      {!posts.length && <div className="empty">Nessun dato ancora. Premi "Aggiorna" (analizza i post recenti di ogni concorrente e trova i più virali).</div>}

      {!!posts.length && (
        <div className="draft-grid">
          {posts.slice(0, 12).map(p => (
            <div key={p.id} className="draft-card" style={{ padding: 16 }}>
              <div className="draft-row" style={{ marginBottom: 8 }}>
                <span className="draft-topic" style={{ fontSize: 13 }}>@{p.competitor_username}</span>
                {p.product_type === 'clips' && <Badge color="purple">Reel</Badge>}
              </div>
              <p className="draft-why" style={{ fontSize: 12, fontStyle: 'normal', lineHeight: 1.5, maxHeight: 90, overflow: 'hidden' }}>
                {(p.caption_text || 'Nessuna caption').slice(0, 200)}{(p.caption_text || '').length > 200 ? '…' : ''}
              </p>
              <div className="draft-row" style={{ marginTop: 10, fontSize: 12, color: 'var(--text3)' }}>
                <span><i className="ti ti-heart" /> {(p.like_count ?? 0).toLocaleString('it-IT')}</span>
                <span><i className="ti ti-message-circle" /> {(p.comment_count ?? 0).toLocaleString('it-IT')}</span>
                {p.play_count > 0 && <span><i className="ti ti-eye" /> {(p.play_count).toLocaleString('it-IT')}</span>}
              </div>
              {videoAnalysis[p.media_pk] && (
                <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid var(--border)' }}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 6 }}>
                    {videoAnalysis[p.media_pk].content_type && <Badge color="green">{videoAnalysis[p.media_pk].content_type}</Badge>}
                    {videoAnalysis[p.media_pk].mood && <Badge color="amber">{videoAnalysis[p.media_pk].mood}</Badge>}
                  </div>
                  {videoAnalysis[p.media_pk].hook_effectiveness && (
                    <p style={{ fontSize: 11, color: 'var(--text2)', lineHeight: 1.4, marginBottom: 4 }}>
                      <strong style={{ color: 'var(--accent2)' }}>Hook: </strong>{videoAnalysis[p.media_pk].hook_effectiveness}
                    </p>
                  )}
                  {videoAnalysis[p.media_pk].pacing_notes && (
                    <p style={{ fontSize: 11, color: 'var(--text2)', lineHeight: 1.4 }}>
                      <strong style={{ color: 'var(--accent2)' }}>Ritmo: </strong>{videoAnalysis[p.media_pk].pacing_notes}
                    </p>
                  )}
                </div>
              )}
              {p.permalink && <a href={p.permalink} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: 'var(--accent2)', marginTop: 8, display: 'inline-block' }}>Apri su Instagram →</a>}

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ReelFilmingTips({ toast }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await sbNew(`reel_filming_tips?user_id=eq.${ANALYTICS_USER_ID}&select=*&order=generated_at.desc&limit=1`);
      setData(d?.[0] || null);
    } catch (e) { toast('Errore caricamento consigli: ' + e.message); }
    setLoading(false);
  }, [toast]);

  useEffect(() => { load(); }, [load]);

  const generate = async () => {
    setGenerating(true);
    toast('Generazione consigli in corso...');
    try {
      const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/generate-reel-filming-tips`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: ANALYTICS_USER_ID }),
      });
      const d = await res.json();
      if (d.error) toast('Errore: ' + d.error);
      else toast('✅ Consigli generati');
    } catch (e) { toast('Errore: ' + e.message); }
    setGenerating(false);
    load();
  };

  if (loading) return null;

  const CATEGORY_ICON = { hook: 'bolt', camera: 'camera', montaggio: 'scissors', sottotitoli: 'align-left', tono: 'microphone', durata: 'clock' };

  return (
    <div style={{ marginBottom: 24 }}>
      <div className="draft-row" style={{ marginBottom: 10 }}>
        <span className="section-title" style={{ marginBottom: 0 }}>Consigli per girare i tuoi Reel a mano</span>
        <button className="btn btn-sm" onClick={generate} disabled={generating}>
          {generating ? 'Generazione...' : <><i className="ti ti-wand" /> Genera consigli</>}
        </button>
      </div>

      {!data && <div className="empty">Nessun consiglio ancora. Premi "Genera consigli" (richiede almeno un'analisi Reel concorrenti già fatta).</div>}

      {data && (
        <>
          <div className="draft-grid">
            {(data.tips || []).map((t, i) => (
              <div key={i} className="draft-card" style={{ padding: 16 }}>
                <div className="draft-row" style={{ marginBottom: 8 }}>
                  <Badge color="purple"><i className={`ti ti-${CATEGORY_ICON[t.categoria] || 'sparkles'}`} /> {t.categoria}</Badge>
                </div>
                <p style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.5, marginBottom: 6 }}>{t.consiglio}</p>
                {t.perche && <p className="draft-why">{t.perche}</p>}
              </div>
            ))}
          </div>
          <p className="draft-score" style={{ marginTop: 10 }}>
            Basato su {data.based_on_count} Reel analizzati · generato {new Date(data.generated_at).toLocaleString('it-IT')}
          </p>
        </>
      )}
    </div>
  );
}

function Crescita({ toast }) {
  const [snapshots, setSnapshots] = useState([]);
  const [profile, setProfile] = useState(null);
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [snaps, profiles, plans] = await Promise.all([
        sbNew(`account_snapshots?user_id=eq.${ANALYTICS_USER_ID}&select=*&order=snapshot_date.asc`),
        sbNew(`viral_profile?user_id=eq.${ANALYTICS_USER_ID}&select=*`),
        sbNew(`editorial_plan?user_id=eq.${ANALYTICS_USER_ID}&select=week_start,week_end,insights,based_on_videos,total_posts&order=week_start.desc&limit=1`),
      ]);
      setSnapshots(snaps || []);
      setProfile(profiles?.[0] || null);
      setPlan(plans?.[0] || null);
    } catch (e) { toast('Errore caricamento crescita: ' + e.message); }
    setLoading(false);
  }, [toast]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="panel"><div className="empty">Caricamento...</div></div>;

  const first = snapshots[0];
  const last = snapshots[snapshots.length - 1];
  const followerDelta = first && last ? last.followers_count - first.followers_count : 0;
  const followerPct = first && first.followers_count ? ((followerDelta / first.followers_count) * 100).toFixed(2) : null;
  const chartData = snapshots.map(s => ({ value: s.followers_count, date: s.snapshot_date }));

  return (
    <div className="panel">
      <div className="panel-header">
        <h1><i className="ti ti-trending-up" /> Crescita & Strategia</h1>
        <button className="btn" onClick={load}><i className="ti ti-refresh" /> Aggiorna</button>
      </div>

      <div className="info-box">
        <i className="ti ti-info-circle" />
        <span>Andamento follower giorno per giorno e pattern strategici (orari, hook, topic) ricavati dall'analisi dei tuoi post. I dati vengono raccolti automaticamente ogni giorno.</span>
      </div>

      {snapshots.length === 0 && <div className="empty">Nessuno snapshot ancora registrato.</div>}

      {snapshots.length > 0 && (
        <div className="draft-card" style={{ padding: 16, marginBottom: 24 }}>
          <div className="draft-row" style={{ marginBottom: 12, flexWrap: 'wrap', gap: 12 }}>
            <div>
              <span className="draft-topic" style={{ fontSize: 22 }}>{last.followers_count.toLocaleString('it-IT')}</span>
              <div className="draft-score">follower al {new Date(last.snapshot_date).toLocaleDateString('it-IT')}</div>
            </div>
            {followerPct !== null && (
              <Badge color={followerDelta >= 0 ? 'green' : 'pink'}>
                {followerDelta >= 0 ? '▲' : '▼'} {followerDelta >= 0 ? '+' : ''}{followerDelta} ({followerPct}%) su {snapshots.length} giorni
              </Badge>
            )}
          </div>
          <MiniLineChart data={chartData} />
          <div className="draft-row" style={{ marginTop: 10, fontSize: 12, color: 'var(--text3)' }}>
            <span>{new Date(first.snapshot_date).toLocaleDateString('it-IT')}</span>
            <span>{new Date(last.snapshot_date).toLocaleDateString('it-IT')}</span>
          </div>
        </div>
      )}

      <CompetitorComparison toast={toast} myFollowers={last?.followers_count} />

      <TopCompetitorPosts toast={toast} />

      <ReelFilmingTips toast={toast} />

      {profile && (
        <div className="draft-grid" style={{ marginBottom: 24 }}>
          <div className="draft-card" style={{ padding: 16 }}>
            <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Pattern vincenti</span>
            <div className="form-group"><label>Giorni migliori</label><span>{(profile.best_days || []).map(d => DAY_NAMES[d]).join(', ') || '—'}</span></div>
            <div className="form-group"><label>Orari migliori</label><span>{(profile.best_hours || []).map(h => `${h}:00`).join(', ') || '—'}</span></div>
            <div className="form-group"><label>Durata ideale (Reel)</label><span>{profile.best_duration_seconds ? `~${profile.best_duration_seconds}s (${profile.best_duration_range?.min}-${profile.best_duration_range?.max}s)` : '—'}</span></div>
            <div className="form-group"><label>Engagement rate medio</label><span>{profile.avg_engagement_rate ? `${(num(profile.avg_engagement_rate) * 100).toFixed(2)}%` : '—'}</span></div>
            {profile.trend_direction && (
              <div className="form-group">
                <label>Trend reach</label>
                <span style={{ color: profile.trend_direction === 'in calo' ? 'var(--red)' : 'var(--green)' }}>
                  {profile.trend_direction} ({num(profile.trend_pct_change)}%) — {Math.round(num(profile.trend_recent_avg_reach))} vs {Math.round(num(profile.trend_previous_avg_reach))} reach medio
                </span>
              </div>
            )}
          </div>

          <div className="draft-card" style={{ padding: 16 }}>
            <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Topic più forti</span>
            {(profile.top_topics || []).slice(0, 5).map((t, i) => (
              <div key={i} className="form-group" style={{ marginBottom: 6 }}>
                <label style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{t.topic}</span>
                  <span style={{ color: 'var(--text3)' }}>{(num(t.avg_engagement) * 100).toFixed(1)}% ER</span>
                </label>
              </div>
            ))}
          </div>

          <div className="draft-card" style={{ padding: 16 }}>
            <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>Hook che funzionano</span>
            {(profile.top_hooks || []).slice(0, 5).map((h, i) => (
              <p key={i} className="draft-why" style={{ marginBottom: 6 }}>• {h}</p>
            ))}
          </div>

          <div className="draft-card" style={{ padding: 16 }}>
            <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>CTA migliori</span>
            {(profile.top_cta || []).map((c, i) => (
              <p key={i} className="draft-why" style={{ marginBottom: 6 }}>• {c}</p>
            ))}
          </div>
        </div>
      )}

      {!profile && <div className="empty">Nessun profilo virale ancora calcolato. Vai su "Bozze virali" e premi "Aggiorna analytics da Instagram".</div>}

      {plan?.insights && (
        <div className="draft-card" style={{ padding: 16 }}>
          <span className="draft-topic" style={{ marginBottom: 10, display: 'block' }}>
            Strategia editoriale — settimana {new Date(plan.week_start).toLocaleDateString('it-IT')} - {new Date(plan.week_end).toLocaleDateString('it-IT')}
          </span>
          <p className="draft-why" style={{ fontSize: 13, fontStyle: 'normal', lineHeight: 1.5 }}>{plan.insights}</p>
          <p className="draft-score" style={{ marginTop: 8 }}>Basato su {plan.based_on_videos} post analizzati · {plan.total_posts} post pianificati</p>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [passwordRecovery, setPasswordRecovery] = useState(false);
  const [reviewerBlockedMsg, setReviewerBlockedMsg] = useState('');
  const [panel, setPanel] = useState('dashboard');
  const [toastMsg, setToastMsg] = useState('');
  const [stats, setStats] = useState({});
  const [posts, setPosts] = useState([]);
  const toast = useCallback(msg => setToastMsg(msg), []);

  useEffect(() => {
    supabaseAuth.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setAuthLoading(false);
    });
    const { data: { subscription } } = supabaseAuth.auth.onAuthStateChange(async (event, session) => {
      if (event === 'PASSWORD_RECOVERY') setPasswordRecovery(true);
      if (event === 'SIGNED_IN' && session?.user?.email?.toLowerCase() === REVIEWER_EMAIL) {
        if (session.user.user_metadata?.reviewer_used) {
          await supabaseAuth.auth.signOut();
          setReviewerBlockedMsg('Questo accesso è monouso ed è già stato utilizzato.');
          return;
        }
        await supabaseAuth.auth.updateUser({ data: { reviewer_used: true, reviewer_login_at: new Date().toISOString() } });
      }
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const isReviewer = session?.user?.email?.toLowerCase() === REVIEWER_EMAIL;
    if (!isReviewer) return;
    const checkExpiry = () => {
      const loginAt = session.user.user_metadata?.reviewer_login_at;
      if (loginAt && Date.now() - new Date(loginAt).getTime() > REVIEWER_SESSION_MAX_MS) {
        supabaseAuth.auth.signOut();
        setReviewerBlockedMsg('Sessione scaduta.');
      }
    };
    checkExpiry();
    const interval = setInterval(checkExpiry, 60 * 1000);
    return () => clearInterval(interval);
  }, [session]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    if (!code && !error) return;
    const cleanUrl = () => window.history.replaceState(null, '', window.location.pathname);
    const state = params.get('state');
    const fbSavedState = sessionStorage.getItem('fb_oauth_state');
    const tiktokSavedState = sessionStorage.getItem('tiktok_oauth_state');
    const provider = state && state === fbSavedState ? 'facebook' : state && state === tiktokSavedState ? 'tiktok' : null;
    sessionStorage.removeItem('fb_oauth_state');
    sessionStorage.removeItem('tiktok_oauth_state');

    if (error) {
      toast(provider === 'tiktok' ? 'Collegamento TikTok annullato' : 'Collegamento Facebook annullato');
      cleanUrl();
      return;
    }
    if (!provider) {
      toast('Errore: stato OAuth non valido, riprova il collegamento');
      cleanUrl();
      return;
    }
    (async () => {
      try {
        if (provider === 'tiktok') {
          const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/tiktok-oauth-callback`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, redirect_uri: TIKTOK_REDIRECT_URI, user_id: ANALYTICS_USER_ID }),
          });
          const data = await res.json();
          if (data.error) toast('Errore collegamento TikTok: ' + data.error);
          else toast(`✅ Account TikTok collegato${data.username ? ': ' + data.username : ''}!`);
        } else {
          const res = await fetch(`${SUPABASE_URL_NEW}/functions/v1/fb-oauth-callback`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${SUPABASE_ANON_KEY}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, redirect_uri: FB_REDIRECT_URI, user_id: ANALYTICS_USER_ID }),
          });
          const data = await res.json();
          if (data.error) toast('Errore collegamento Facebook: ' + data.error);
          else toast(`✅ Pagina Facebook collegata: ${data.page_name}`);
        }
      } catch (e) { toast('Errore: ' + e.message); }
      cleanUrl();
      setPanel('config');
    })();
  }, [toast]);

  const handleLogout = async () => {
    await supabaseAuth.auth.signOut();
    setSession(null);
  };

  useEffect(() => {
    if (!session) return;
    (async () => {
      try {
        const [flows, leads, kws, msgs] = await Promise.all([sb('ig_flows?select=id&is_active=eq.true'), sb('ig_leads?select=id'), sb('ig_keywords?select=id&is_active=eq.true'), sb('ig_messages?select=id&direction=eq.outbound')]);
        setStats({ flows: flows.length, leads: leads.length, keywords: kws.length, messages: msgs.length });
      } catch (e) { console.error(e); }
      try {
        const res = await fetch(`https://graph.instagram.com/v19.0/${IG_USER_ID}/media?fields=id,caption,media_type,media_url,thumbnail_url,timestamp,like_count,comments_count,permalink&limit=6&access_token=${IG_TOKEN}`);
        const data = await res.json();
        setPosts(data.data || []);
      } catch (e) { console.error(e); }
    })();
  }, [session]);

  const nav = [
    { id: 'dashboard', icon: 'layout-dashboard', label: 'Dashboard' },
    { id: 'posts', icon: 'photo', label: 'Post' },
    { id: 'bozze', icon: 'sparkles', label: 'Bozze virali' },
    { id: 'crescita', icon: 'trending-up', label: 'Crescita & Strategia' },
    { id: 'performance', icon: 'chart-line', label: 'Performance' },
    { id: 'flows', icon: 'git-branch', label: 'Flow' },
    { id: 'keywords', icon: 'tag', label: 'Parole chiave' },
    { id: 'leads', icon: 'users', label: 'Lead' },
    { id: 'comments', icon: 'message-forward', label: 'Auto-DM commenti' },
    { id: 'config', icon: 'settings', label: 'Configurazione' },
  ];

  if (authLoading) {
    return (
      <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0f1117',color:'white',fontSize:'16px'}}>
        Caricamento...
      </div>
    );
  }

  if (passwordRecovery) {
    return <ResetPasswordScreen onDone={() => { setPasswordRecovery(false); toast('Password aggiornata, ora sei loggata'); }} />;
  }

  if (!session) {
    return <LoginScreen onLogin={() => {}} externalError={reviewerBlockedMsg} />;
  }

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-icon"><i className="ti ti-brand-instagram" /></div>
          <div><div className="logo-name">MyChat</div><div className="logo-sub">Instagram DM</div></div>
        </div>
        <nav className="sidebar-nav">
          {nav.map(n => <button key={n.id} className={`nav-item ${panel === n.id ? 'active' : ''}`} onClick={() => setPanel(n.id)}><i className={`ti ti-${n.icon}`} /><span>{n.label}</span></button>)}
        </nav>
        <div className="sidebar-footer">
          <div className="status-dot" /><span>@neuroplasticity_training</span>
          <button onClick={handleLogout} style={{marginLeft:'auto',background:'transparent',border:'1px solid #444',color:'#aaa',padding:'4px 10px',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>Esci</button>
        </div>
      </aside>
      <main className="main">
        {panel === 'dashboard' && <Dashboard stats={stats} posts={posts} />}
        {panel === 'posts' && <Posts toast={toast} />}
        {panel === 'bozze' && <BozzeVirali toast={toast} />}
        {panel === 'crescita' && <Crescita toast={toast} />}
        {panel === 'performance' && <Performance toast={toast} />}
        {panel === 'flows' && <Flows toast={toast} />}
        {panel === 'keywords' && <Keywords toast={toast} />}
        {panel === 'leads' && <Leads toast={toast} />}
        {panel === 'comments' && <CommentRules toast={toast} />}
        {panel === 'config' && <Config toast={toast} />}
      </main>
      <Toast msg={toastMsg} onHide={() => setToastMsg('')} />
    </div>
  );
}
